import React, { FC, memo } from 'react'

import { TypicalAccommodationsSectionTransport } from '../../../transports/region-landing-page-transport'
import ExternalLink from '../../common/external-link'
import {
    Container,
    IconBox,
    Image,
    InnerContainer,
    MenuContainer,
    MenuWrapper,
    SubtitleSpan,
    TitleSpan,
} from './styles'
import { useTranslation } from '../../../hooks/locale'
import { getIconFromId } from '../../../models/landing-page/utils'
import { AnyStyledComponent } from 'styled-components'
import { Title, TitleContainer } from '../common/styles'

interface Props {
    typicalAccommodationsSection: TypicalAccommodationsSectionTransport
}

const AccommodationSection: FC<Props> = ({ typicalAccommodationsSection }) => {
    const { t } = useTranslation()
    const { heading, items } = typicalAccommodationsSection

    return (
        <Container id="accommodation">
            <TitleContainer>
                <Title>{heading}</Title>
            </TitleContainer>
            <InnerContainer>
                {items.map(item => (
                    <MenuWrapper key={item.link}>
                        <ExternalLink as={MenuContainer} title={item.linkTitle} href={item.link} noCrawl={item.noCrawl}>
                            <IconBox>
                                <Image as={getIconFromId(item.id) as AnyStyledComponent} />
                            </IconBox>
                            <TitleSpan>{item.title}</TitleSpan>
                            <SubtitleSpan>
                                {item.count} {item.count === 1 ? t('accommodation') : t('accommodations')}
                            </SubtitleSpan>
                        </ExternalLink>
                    </MenuWrapper>
                ))}
            </InnerContainer>
        </Container>
    )
}

export default memo(AccommodationSection)
